(function () {
  "use strict";
  if (window.__faCartDrawerLoaded) return;
  window.__faCartDrawerLoaded = true;

  var CONFIG = window.FA_CART_CONFIG || {};
  var DISCOUNT_KEY = "fa_cart_discount";

  // Old Money skin knobs — defaults applied here so old saved settings
  // (no styleExtras at all) behave sensibly.
  var OM = (CONFIG.styleExtras && CONFIG.styleExtras.om) || {};
  var OM_SHOW_DISCOUNTS = OM.showDiscountsRow !== false;
  var OM_REMOVE_LABEL = OM.removeLabel || "Remove";
  var OM_QV_ATC_LABEL = OM.qvAtcLabel || "Add to cart";
  var OM_QV_SOLDOUT_LABEL = OM.qvSoldOutLabel || "Sold out";
  var OM_RAIL = OM.railEnabled !== false;
  // Quick view: the rail "+" opens the side panel; when disabled the
  // "+" falls back to a direct first-available-variant add.
  var OM_QV = OM.qvEnabled !== false;

  function safe(fn) {
    return function () {
      try { return fn.apply(this, arguments); }
      catch (e) { try { console.warn("[fa-cart]", e); } catch (_) {} }
    };
  }

  function $(sel, root) { return (root || document).querySelector(sel); }

  // Duizendtal-teken, centen-teken en aantal decimalen per Shopify-placeholder.
  var MONEY_RULES = {
    amount: [",", ".", 2],
    amount_no_decimals: [",", "", 0],
    amount_with_comma_separator: [".", ",", 2],
    amount_no_decimals_with_comma_separator: [".", "", 0],
    amount_with_apostrophe_separator: ["'", ".", 2],
    amount_with_space_separator: [" ", ",", 2],
    amount_no_decimals_with_space_separator: [" ", "", 0],
    amount_with_period_and_space_separator: [" ", ".", 2],
  };

  // De winkel bepaalt hoe een bedrag geschreven wordt, niet de bezoeker. Met
  // Intl.NumberFormat(undefined, ...) las de browser zijn EIGEN locale, dus
  // dezelfde Nederlandse winkel toonde 64,95 aan de een en 64.95 aan de ander,
  // en geen van beide hoefde te kloppen met de productpagina eromheen.
  // CONFIG.moneyFormat komt vers uit shop.money_format bij elke paginarender;
  // ontbreekt hij (oude snippet nog op het thema), dan blijft Intl de terugval.
  function formatMoney(cents, currency) {
    if (cents == null || isNaN(cents)) return "";
    var fmt = CONFIG.moneyFormat;
    if (typeof fmt === "string" && fmt) {
      var re = /\{\{\s*(\w+)\s*\}\}/;
      var m = fmt.match(re);
      if (m) {
        var rule = MONEY_RULES[m[1]] || MONEY_RULES.amount;
        var parts = (cents / 100).toFixed(rule[2]).split(".");
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, rule[0]);
        return fmt.replace(re, whole + (parts[1] ? rule[1] + parts[1] : ""));
      }
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "USD",
        currencyDisplay: "narrowSymbol",
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // Old-money footer rows read "$54.99 USD" — amount + ISO code suffix.
  function formatMoneyCode(cents, currency) {
    var cur = currency || state.currency || "USD";
    var base = formatMoney(cents, cur);
    if (!base) return base;
    return base + " " + String(cur).toUpperCase();
  }

  // XSS safety contract for the 'el.innerHTML = html' call-sites in
  // this file (renderItems item, renderUpsells card, and the
  // shipbarText template):
  //   - Every user-supplied value (product titles, URLs, prices) MUST
  //     pass through 'escapeHtml()' before string-concatenation.
  //   - Template literals embedded in CONFIG (e.g. unlockedMessage) are
  //     operator-set — they are trusted to be safe HTML by contract.
  //   - escapeHtml below escapes &, <, >, ", ' — the standard set that
  //     blocks attribute-break, tag-open, and quote-break XSS.
  // If you add a new user-data interpolation, audit that escapeHtml
  // wraps it before assignment, OR use createElement+textContent.
  // NB: backticks would prematurely close this enclosing template
  // literal — use single quotes in this comment block only.
  function escapeHtml(s) {
    if (s == null) return "";
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function fetchJson(url, opts) {
    return fetch(url, Object.assign({ credentials: "same-origin", headers: { Accept: "application/json" } }, opts || {}))
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error("HTTP " + r.status + ": " + t.slice(0, 200)); });
        return r.json();
      });
  }

  function getCart() { return fetchJson("/cart.js"); }

  function changeLine(line, quantity) {
    return fetchJson("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
  }

  function addItem(variantId, quantity) {
    return fetchJson("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    });
  }

  function fetchProduct(handle) {
    return fetchJson("/products/" + encodeURIComponent(handle) + ".js");
  }

  // ─── Progress / checkpoint computation (inlined; mirrors
  // computeProgress() in src/lib/cart-drawer/settings.ts) ───
  // Supports two tier flavors:
  //   * "amount"  — subtotal in cents crosses thresholdCents
  //   * "quantity" — item_count crosses thresholdQuantity
  // Old config rows without a thresholdType fall back to "amount"
  // so existing installs stay backward-compatible.
  function tierMetric(t) { return t && t.thresholdType === "quantity" ? "quantity" : "amount"; }
  function tierThreshold(t) {
    return tierMetric(t) === "quantity" ? (t.thresholdQuantity || 0) : (t.thresholdCents || 0);
  }
  function computeProgress(subtotalCents, itemCount) {
    var cps = CONFIG.discountCheckpoints || { enabled: false, tiers: [] };
    var fs = CONFIG.freeShipping || { enabled: false, threshold: 0 };
    var qty = itemCount || 0;
    var rawTiers = cps.enabled ? (cps.tiers || []) : [];
    var enabledTiers = [];
    for (var ei = 0; ei < rawTiers.length; ei++) {
      if (rawTiers[ei].enabled !== false) enabledTiers.push(rawTiers[ei]);
    }
    var tiers = enabledTiers.slice().sort(function (a, b) {
      return tierThreshold(a) - tierThreshold(b);
    });
    function met(t) {
      return tierMetric(t) === "quantity"
        ? qty >= (t.thresholdQuantity || 0)
        : subtotalCents >= (t.thresholdCents || 0);
    }
    var unlockedTiers = [];
    for (var i = 0; i < tiers.length; i++) if (met(tiers[i])) unlockedTiers.push(tiers[i]);
    var bestUnlocked = unlockedTiers.length ? unlockedTiers[unlockedTiers.length - 1] : null;
    var nextTier = null;
    for (var j = 0; j < tiers.length; j++) {
      if (!met(tiers[j])) { nextTier = tiers[j]; break; }
    }
    var shippingEnabled = !!(fs.enabled && fs.threshold > 0);
    var shippingMet = shippingEnabled && subtotalCents >= fs.threshold;
    var shippingRemainingCents = shippingEnabled ? Math.max(0, fs.threshold - subtotalCents) : 0;

    // Bar axis: quantity only when EVERY enabled tier is quantity
    // and free shipping is off; otherwise the bar is in cents.
    var allQuantity = tiers.length > 0;
    for (var aq = 0; aq < tiers.length; aq++) {
      if (tierMetric(tiers[aq]) !== "quantity") { allQuantity = false; break; }
    }
    var barAxis = (allQuantity && !shippingEnabled) ? "quantity" : "amount";

    var seen = {};
    var markers = [];
    function pushMarker(v) { if (v > 0 && !seen[v]) { seen[v] = true; markers.push(v); } }
    if (barAxis === "amount") {
      if (shippingEnabled) pushMarker(fs.threshold);
      for (var k = 0; k < tiers.length; k++) {
        if (tierMetric(tiers[k]) === "amount") pushMarker(tiers[k].thresholdCents || 0);
      }
    } else {
      for (var kq = 0; kq < tiers.length; kq++) {
        if (tierMetric(tiers[kq]) === "quantity") pushMarker(tiers[kq].thresholdQuantity || 0);
      }
    }
    markers.sort(function (a, b) { return a - b; });
    var max = markers.length ? markers[markers.length - 1] : 0;
    var current = barAxis === "amount" ? subtotalCents : qty;
    var fillPercent = max > 0 ? Math.min(100, (current / max) * 100) : 0;

    var nextRemCents = 0, nextRemQty = 0;
    if (nextTier) {
      if (tierMetric(nextTier) === "quantity") {
        nextRemQty = Math.max(0, (nextTier.thresholdQuantity || 0) - qty);
      } else {
        nextRemCents = Math.max(0, (nextTier.thresholdCents || 0) - subtotalCents);
      }
    }

    return {
      unlockedTiers: unlockedTiers,
      bestUnlocked: bestUnlocked,
      nextTier: nextTier,
      nextTierRemainingCents: nextRemCents,
      nextTierRemainingQuantity: nextRemQty,
      shippingMet: shippingMet,
      shippingRemainingCents: shippingRemainingCents,
      barAxis: barAxis,
      markers: markers,
      max: max,
      fillPercent: fillPercent,
    };
  }

  function fillTemplate(tpl, vars) {
    if (!tpl) return "";
    return String(tpl).replace(/\{(\w+)\}/g, function (m, key) {
      return vars && vars[key] != null ? String(vars[key]) : m;
    });
  }

  var elements = {};
  var state = { cart: null, currency: "USD", unlockedCode: "", compareAt: {} };

  function openDrawer() {
    var d = elements.drawer;
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add("is-open"); });
    document.body.style.overflow = "hidden";
    // Always re-enable the checkout button on (re)open — covers
    // back-button returns where the previous disabled state survived.
    var btn = elements.checkout;
    if (btn) btn.removeAttribute("disabled");
  }

  function closeDrawer() {
    var d = elements.drawer;
    if (!d) return;
    // The quick-view panel never outlives the drawer.
    if (elements.qv) elements.qv.classList.remove("is-open");
    d.classList.remove("is-open");
    setTimeout(function () { d.hidden = true; document.body.style.overflow = ""; }, 360);
  }

  function renderProgressBar(cart) {
    var bar = elements.shipbar;
    if (!bar) return;
    var fsEnabled = !!(CONFIG.freeShipping && CONFIG.freeShipping.enabled && CONFIG.freeShipping.threshold > 0);
    var cpEnabled = !!(CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.enabled && (CONFIG.discountCheckpoints.tiers || []).length);
    if (!fsEnabled && !cpEnabled) { bar.hidden = true; return; }
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var itemCount = cart.item_count || 0;
    var prog = computeProgress(subtotal, itemCount);
    bar.hidden = false;
    // Old-money bar mechanic: the fill spans the full track and scales
    // via the --percentage custom property (scaleX in css-om).
    elements.shipbarFill.style.setProperty("--percentage", String(prog.fillPercent / 100));

    // Message — picks free-shipping copy when applicable, otherwise
    // cycles through tier progress / unlocked / shipping-met.
    var msg = "";
    if (fsEnabled && !prog.shippingMet) {
      var remaining = formatMoney(prog.shippingRemainingCents, state.currency);
      msg = fillTemplate(
        (CONFIG.freeShipping && CONFIG.freeShipping.messageBelow) || "Spend {remaining} more for free shipping",
        { remaining: "<strong>" + remaining + "</strong>" }
      );
    } else if (cpEnabled && prog.nextTier) {
      var nt = prog.nextTier;
      var isQty = (nt.thresholdType === "quantity");
      var vars = {
        remaining: isQty ? "" : ("<strong>" + formatMoney(prog.nextTierRemainingCents, state.currency) + "</strong>"),
        // {remainingQty} = bold count only; {items} pluralises separately so
        // templates control word order ("Add 2 more items to unlock ...").
        remainingQty: isQty ? ("<strong>" + prog.nextTierRemainingQuantity + "</strong>") : "",
        items: isQty
          ? (prog.nextTierRemainingQuantity === 1
              ? ((CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.itemWordSingular) || "item")
              : ((CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.itemWordPlural) || "items"))
          : "",
        percent: nt.percent,
        label: escapeHtml(nt.label || "")
      };
      msg = fillTemplate(
        (CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.progressMessage) || (isQty ? "Add {remainingQty} more {items} for {percent}% off" : "Spend {remaining} more for {percent}% off"),
        vars
      );
    } else if (cpEnabled && prog.bestUnlocked) {
      msg = fillTemplate(
        (CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.unlockedMessage) || "{percent}% off unlocked!",
        { percent: prog.bestUnlocked.percent, label: escapeHtml(prog.bestUnlocked.label || "") }
      );
    } else if (fsEnabled && prog.shippingMet) {
      msg = escapeHtml((CONFIG.freeShipping && CONFIG.freeShipping.messageMet) || "You qualify for free shipping");
    }
    elements.shipbarText.innerHTML = msg;

    // Old Money markers: small circles sitting ON the thin track with
    // a mini uppercase label underneath — minimalist, no pills. Same
    // axis/threshold semantics as the default renderer.
    var track = elements.shipbarTrack;
    if (track) {
      var old = track.querySelectorAll(".fa-cart-shipbar-marker");
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      if (prog.max > 0) {
        var current = prog.barAxis === "amount" ? subtotal : itemCount;
        // Resolve each marker value back to its tier (for the %
        // label under the dot).
        var tiersForLookup = (CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.tiers) || [];
        function findTier(value) {
          for (var t = 0; t < tiersForLookup.length; t++) {
            var tier = tiersForLookup[t];
            if (tier.enabled === false) continue;
            var tv = tier.thresholdType === "quantity" ? (tier.thresholdQuantity || 0) : (tier.thresholdCents || 0);
            if (tv === value) return tier;
          }
          return null;
        }
        for (var m = 0; m < prog.markers.length; m++) {
          var v = prog.markers[m];
          var pct = (v / prog.max) * 100;
          var el = document.createElement("span");
          el.className = "fa-cart-shipbar-marker";
          if (current >= v) el.classList.add("is-met");
          el.style.left = pct + "%";
          // Operator nudge: shift the markers horizontally (negative =
          // left). margin-left offsets an absolutely-positioned element
          // from its 'left' anchor, so it composes cleanly with the
          // centering transform on the marker.
          var markerOffset = (CONFIG.discountCheckpoints && CONFIG.discountCheckpoints.markerOffsetPx) || 0;
          if (markerOffset) el.style.marginLeft = markerOffset + "px";
          var dot = document.createElement("span");
          dot.className = "fa-cart-om-marker-dot";
          el.appendChild(dot);
          var lab = document.createElement("span");
          lab.className = "fa-cart-om-marker-label";
          var tier = findTier(v);
          if (tier && tier.percent) {
            lab.textContent = tier.percent + "%";
          } else {
            // Free-shipping marker (no tier).
            lab.textContent = "FREE";
            el.classList.add("is-shipping");
          }
          el.appendChild(lab);
          track.appendChild(el);
        }
      }
    }

    // Only code-based tiers (not Shopify-automatic) need a
    // ?discount=CODE URL hack at checkout. Automatic discounts are
    // applied server-side by Shopify when the threshold is met.
    state.unlockedCode =
      prog.bestUnlocked && prog.bestUnlocked.discountCode && !prog.bestUnlocked.automatic
        ? String(prog.bestUnlocked.discountCode)
        : "";
  }

  function renderItems(cart) {
    var list = elements.items;
    var empty = elements.empty;
    if (!list) return;
    // Clear via replaceChildren so we never even briefly assign to
    // innerHTML — safer pattern for static linters + future refactors.
    list.replaceChildren();
    if (!cart.items || cart.items.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var idx = i + 1;
      var li = document.createElement("li");
      li.className = "fa-cart-item";
      li.setAttribute("data-line", String(idx));
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || "");
      var variantRaw = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      // Old-money renders variant options comma-separated ("Beige, S")
      // instead of Shopify's "Beige / S".
      var variant = variantRaw ? String(variantRaw).replace(/\s*\/\s*/g, ", ") : "";
      var q = item.quantity || 1;
      var lineNow = item.final_line_price != null ? item.final_line_price : item.line_price;
      // Product compare-at ("was") price — fetched per variant since
      // /cart.js doesn't carry it. Use it as the struck price when the
      // variant is on sale (compare_at > current unit price).
      var cmpUnit = state.compareAt[item.variant_id];
      var cmpLine = (cmpUnit && cmpUnit > (item.price || 0)) ? cmpUnit * q : 0;
      var lineWas = Math.max(item.original_line_price != null ? item.original_line_price : lineNow, cmpLine);
      var pct = state.discountPercent || 0;
      // Only synthesise the tier preview when Shopify has NOT already
      // allocated the discount to this line. ORDER-class automatic
      // discounts are not allocated per line, so the drawer has to show
      // them itself; PRODUCT-class ones ARE, and re-applying pct on top
      // discounts the same line twice. That shipped on 2026-07-31 when
      // the ladder moved to PRODUCT class: a $131.10 cart displayed as
      // $98.33. Detect the allocation instead of assuming either shape.
      var faAllocated =
        (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) ||
        (item.original_line_price != null && lineNow < item.original_line_price);
      var finalLine = (pct > 0 && !faAllocated) ? Math.round(lineNow * (100 - pct) / 100) : lineNow;
      // Display-only: berekende/gekorte bedragen naar BOVEN op $0.05
      // (125.92 → 125.95) — checkout rekent de exacte cent, dus getoond is
      // nooit lager dan betaald. Charm-prijzen (.95/.90) veranderen niet.
      finalLine = Math.ceil(finalLine / 5) * 5;
      // Struck "before" price = the higher of the Shopify original (product
      // compare-at / cart discount) and the current line price.
      var compareLine = state.showSavings ? Math.max(lineWas, lineNow) : lineNow;
      var hasSale = compareLine > finalLine;
      // Price row shows LINE totals: the struck compare-at scales with
      // quantity and the final price is the pro-rata line amount (incl.
      // allocated cart/tier discounts) — qty 2 shows 2x, not per-unit.
      var html = '';
      html += '<img class="fa-cart-item-img" src="' + escapeHtml(img) + '" alt="" loading="lazy" />';
      html += '<div class="fa-cart-item-info">';
      html +=   '<div class="fa-cart-om-item-top">';
      html +=     '<div class="fa-cart-om-item-main">';
      html +=       '<a class="fa-cart-item-title" href="' + escapeHtml(item.url || "#") + '">' + escapeHtml(item.product_title || item.title || "") + '</a>';
      html +=       '<div class="fa-cart-item-prices">';
      if (hasSale) {
        html +=       '<del class="fa-cart-item-price-compare">' + escapeHtml(formatMoney(compareLine, state.currency)) + '</del>';
        html +=       '<ins class="fa-cart-item-price-final is-sale">' + escapeHtml(formatMoney(finalLine, state.currency)) + '</ins>';
      } else {
        html +=       '<ins class="fa-cart-item-price-final">' + escapeHtml(formatMoney(finalLine, state.currency)) + '</ins>';
      }
      html +=       '</div>';
      if (variant) html += '<div class="fa-cart-item-variant">' + escapeHtml(variant) + '</div>';
      html +=     '</div>';
      html +=     '<div class="fa-cart-om-item-linetotal"><ins>' + escapeHtml(formatMoney(finalLine, state.currency)) + '</ins></div>';
      html +=   '</div>';
      html +=   '<div class="fa-cart-om-item-actions">';
      html +=     '<div class="fa-cart-qty">';
      // Old-money's literal qty glyphs: 8×2 minus / 8×8 plus filled
      // bars (their markup ships fill="var(--color-body)"; currentColor
      // resolves to the same #151515 ink here).
      // Old-money: minus is DISABLED at qty 1 — removing goes via REMOVE
      // only; from 2 up the minus decrements normally.
      html +=       '<button type="button" data-qty-dec' + (item.quantity <= 1 ? ' disabled' : '') + ' aria-label="Decrease"><svg width="8" height="2" viewBox="0 0 8 2" fill="none" aria-hidden="true"><path d="M3.49692e-08 1.39998L0 0.599976L8 0.599976V1.39998L3.49692e-08 1.39998Z" fill="currentColor"/></svg></button>';
      html +=       '<span class="fa-cart-qty-value">' + item.quantity + '</span>';
      html +=       '<button type="button" data-qty-inc aria-label="Increase"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M3.6 0H4.4V8H3.6V0Z" fill="currentColor"/><path d="M3.49692e-08 4.4L0 3.6L8 3.6V4.4L3.49692e-08 4.4Z" fill="currentColor"/></svg></button>';
      html +=     '</div>';
      html +=     '<button type="button" class="fa-cart-om-remove" data-qty-remove>' + escapeHtml(OM_REMOVE_LABEL) + '</button>';
      html +=   '</div>';
      html += '</div>';
      li.innerHTML = html;
      list.appendChild(li);
    }
  }

  function renderFooter(cart) {
    // Item count badge in the header.
    if (elements.count) elements.count.textContent = String(cart.item_count || 0);

    var subtotalNow = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    // Compare-at = sum of original_line_price across items (pre-discount).
    var compareSum = 0;
    // True as soon as Shopify has allocated a discount to any line —
    // see the note at finalPay below.
    var faAnyAllocated = false;
    if (cart.items && cart.items.length) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var itNow = it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
        if ((it.line_level_discount_allocations && it.line_level_discount_allocations.length > 0) ||
            (it.original_line_price != null && itNow < it.original_line_price)) {
          faAnyAllocated = true;
        }
        var ocl = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
        // Include the product compare-at ("was") line when on sale.
        var cu = state.compareAt[it.variant_id];
        var cl = (cu && cu > (it.price || 0)) ? cu * it.quantity : 0;
        compareSum += Math.max(ocl, cl);
      }
    }
    // Apply the unlocked tier % (the automatic discount Shopify applies at
    // checkout) so the total previews what the customer actually pays.
    var pct = state.discountPercent || 0;
    // Same trap as the line rows: items_subtotal_price already carries
    // line-allocated discounts, so previewing the tier again would
    // double it. faAnyAllocated is set while summing the compare-at.
    var finalPay = (pct > 0 && !faAnyAllocated) ? Math.round(subtotalNow * (100 - pct) / 100) : subtotalNow;
    // Zelfde 5-cent display-afronding als de line rows (zie boven).
    finalPay = Math.ceil(finalPay / 5) * 5;
    var compare = state.showSavings ? Math.max(compareSum, subtotalNow) : subtotalNow;
    var savings = Math.max(0, compare - finalPay);

    if (elements.subtotalFinal) {
      elements.subtotalFinal.textContent = formatMoneyCode(finalPay, state.currency);
    }
    if (elements.subtotalCompare) {
      if (savings > 0) {
        elements.subtotalCompare.textContent = formatMoneyCode(compare, state.currency);
        elements.subtotalCompare.hidden = false;
      } else {
        elements.subtotalCompare.hidden = true;
        elements.subtotalCompare.textContent = "";
      }
    }
    if (elements.savings) {
      if (savings > 0) {
        // Old-money shows the saved amount POSITIVE ("$312.02 USD"), no minus.
        elements.savings.textContent = formatMoneyCode(savings, state.currency);
        elements.savings.hidden = false;
      } else {
        elements.savings.hidden = true;
        elements.savings.textContent = "";
      }
    }
    // "Discounts — $104.51 USD" row: visible only with a real saving
    // AND the operator toggle on.
    if (elements.omDiscountsRow) {
      elements.omDiscountsRow.hidden = !(savings > 0 && OM_SHOW_DISCOUNTS);
    }
    // "Checkout • $54.99" — live total on the button (element only
    // exists when styleExtras.om.checkoutShowsTotal).
    if (elements.checkoutTotal) {
      elements.checkoutTotal.textContent = formatMoney(finalPay, state.currency);
    }
  }

  function renderSticky(cart) {
    if (!elements.sticky) return;
    var count = cart.item_count || 0;
    if (count <= 0) {
      elements.sticky.hidden = true;
      return;
    }
    elements.sticky.hidden = false;
    if (elements.stickyCount) elements.stickyCount.textContent = String(count);
  }

  // /cart.js doesn't include a line's compare_at_price, so fetch each
  // variant's compare-at once (cached on state) and re-render the prices
  // when it lands — lets on-sale products show their struck "was" price in
  // the cart lines + total, same as the upsells already do.
  function ensureCompareAt(cart) {
    if (!cart || !cart.items) return;
    var need = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id != null && it.handle && state.compareAt[it.variant_id] === undefined) {
        state.compareAt[it.variant_id] = null; // in-flight marker — avoids refetch
        need.push(it);
      }
    }
    if (need.length === 0) return;
    Promise.all(need.map(function (it) {
      return fetchProduct(it.handle).then(function (p) {
        var ca = 0;
        if (p && p.variants) {
          for (var v = 0; v < p.variants.length; v++) {
            if (String(p.variants[v].id) === String(it.variant_id)) {
              ca = p.variants[v].compare_at_price || 0;
              break;
            }
          }
        }
        state.compareAt[it.variant_id] = ca;
      }).catch(function () { state.compareAt[it.variant_id] = 0; });
    })).then(function () {
      if (state.cart) { renderItems(state.cart); renderFooter(state.cart); }
    });
  }

  function render(cart) {
    state.cart = cart;
    state.currency = cart.currency || state.currency;
    // Old-money's empty drawer is JUST header + empty block — the tier
    // bar, footer and rail hide via this root class.
    if (elements.drawer) elements.drawer.classList.toggle("fa-cart--empty", !(cart.items && cart.items.length));
    // Rail follows the FIRST cart item (old-money keys recommendations on
    // it). init() runs before the first /cart.js resolves, so the rail must
    // re-render whenever that anchor changes — otherwise it computes once
    // against an empty cart and stays hidden forever.
    var railAnchor = cart.items && cart.items[0] ? cart.items[0].product_id : null;
    if (railAnchor !== state.railAnchor) {
      state.railAnchor = railAnchor;
      renderUpsells();
    }
    ensureCompareAt(cart);
    // Preview the unlocked tier discount. Shopify AUTOMATIC discounts are
    // applied at checkout and are NOT reflected in /cart.js, so the drawer
    // computes the effective % from the configured tiers and applies it to
    // the displayed prices itself (item lines + total) — otherwise the
    // shopper sees full price in the cart and the saving only appears at
    // checkout. computeProgress() picks the highest unlocked tier.
    var cps = CONFIG.discountCheckpoints;
    // Operator toggle: hide ALL discounted-price UI (struck prices, green
    // totals, savings badge) when off. Default ON (only false disables).
    var showSavings = !(cps && cps.showSavings === false);
    var pct = 0;
    if (showSavings && cps && cps.enabled && (cps.tiers || []).length) {
      var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : (cart.total_price || 0);
      var prog = computeProgress(sub, cart.item_count || 0);
      pct = prog.bestUnlocked && prog.bestUnlocked.percent ? prog.bestUnlocked.percent : 0;
    }
    state.showSavings = showSavings;
    state.discountPercent = pct;
    renderItems(cart);
    renderProgressBar(cart);
    renderFooter(cart);
    renderSticky(cart);
  }

  function refresh() {
    return getCart().then(render).catch(function (err) { console.warn("[fa-cart] refresh failed", err); });
  }

  // Resolve the rail products.
  // - "manual"              → operator-curated handles via /products/{handle}.js
  // - "related"/"complementary" → the PUBLIC recommendations JSON keyed
  //   on the first cart item's product_id, limit 4 (old-money's own
  //   data source for the drawer rail). No manual fallback for the
  //   dynamic modes: an empty cart, an empty result or a fetch error
  //   simply HIDES the rail (renderUpsells hides on []).
  function fetchUpsellProducts() {
    var cfg = CONFIG.upsells || {};
    var mode = cfg.mode || "manual";
    var cart = state.cart;
    var inCart = {};
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_id != null) inCart[String(cart.items[i].product_id)] = true;
      }
    }
    if (mode === "manual") {
      var handles = (cfg.productHandles || []).filter(Boolean).slice(0, 4);
      if (handles.length === 0) return Promise.resolve([]);
      return Promise.all(handles.map(function (h) {
        return fetchProduct(h).catch(function () { return null; });
      })).then(function (arr) {
        return arr.filter(function (p) { return p && !inCart[String(p.id)]; });
      });
    }
    if (!cart || !cart.items || cart.items.length === 0) return Promise.resolve([]);
    var anchor = cart.items[0];
    var productId = anchor && anchor.product_id;
    if (productId == null) return Promise.resolve([]);
    var intent = mode === "complementary" ? "complementary" : "related";
    return fetchJson(
      "/recommendations/products.json?product_id=" + encodeURIComponent(String(productId)) +
      "&intent=" + intent + "&limit=4"
    ).then(function (res) {
      var products = (res && res.products) || [];
      return products.filter(function (p) { return p && !inCart[String(p.id)]; }).slice(0, 4);
    }).catch(function (err) {
      try { console.warn("[fa-cart] recommendations failed — hiding rail", err); } catch (_) {}
      return [];
    });
  }

  function renderUpsells() {
    if (!CONFIG.upsells || !CONFIG.upsells.enabled || !OM_RAIL) return;
    var wrap = elements.upsellsWrap;
    var list = elements.upsells;
    if (!list || !wrap) return;
    fetchUpsellProducts().then(function (products) {
      products = (products || []).filter(Boolean);
      if (products.length === 0) { wrap.hidden = true; return; }
      list.replaceChildren();
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var variant = null;
        if (p.variants && p.variants.length) {
          for (var v = 0; v < p.variants.length; v++) {
            if (p.variants[v].available) { variant = p.variants[v]; break; }
          }
          if (!variant) variant = p.variants[0];
        }
        if (!variant) continue;
        var compareAt = variant.compare_at_price != null ? variant.compare_at_price : (p.compare_at_price || 0);
        var price = variant.price != null ? variant.price : p.price;
        var hasSale = compareAt && compareAt > price;
        var img = p.featured_image || (p.images && p.images[0]) || "";
        var url = p.url || (p.handle ? "/products/" + p.handle : "#");
        var card = document.createElement("div");
        card.className = "fa-cart-upsell";
        // Rail card: full-width photo, title link, del/ins price pair
        // (no Save chip — this skin keeps the card quiet), square teal
        // "+" bottom-right that opens the quick view.
        var html = '';
        html += '<a class="fa-cart-om-upsell-media" href="' + escapeHtml(url) + '" tabindex="-1" aria-hidden="true">';
        html +=   '<img class="fa-cart-upsell-img" src="' + escapeHtml(img) + '" alt="" loading="lazy" />';
        html += '</a>';
        html += '<div class="fa-cart-upsell-body">';
        html +=   '<a class="fa-cart-upsell-title" href="' + escapeHtml(url) + '">' + escapeHtml(p.title || "") + '</a>';
        html +=   '<div class="fa-cart-upsell-prices">';
        if (hasSale) {
          html += '<del class="fa-cart-upsell-price-compare">' + escapeHtml(formatMoney(compareAt, state.currency)) + '</del>';
          html += '<ins class="fa-cart-upsell-price-final is-sale">' + escapeHtml(formatMoney(price, state.currency)) + '</ins>';
        } else {
          html += '<ins class="fa-cart-upsell-price-final">' + escapeHtml(formatMoney(price, state.currency)) + '</ins>';
        }
        html +=   '</div>';
        html += '</div>';
        // The "+" — a text glyph inside a span (the wipe hover needs
        // the span layered above the ::before sheet). With the quick
        // view enabled it opens the option panel; otherwise it adds
        // the first available variant directly.
        if (OM_QV && p.handle) {
          html += '<button type="button" class="fa-cart-upsell-add fa-cart-om-upsell-add" data-fa-om-qv-open="' + escapeHtml(String(p.handle)) + '" data-qv-url="' + escapeHtml(url) + '" data-qv-title="' + escapeHtml(p.title || "") + '" aria-label="' + escapeHtml((CONFIG.copy && CONFIG.copy.upsellAddText) || "Quick view") + '"><span aria-hidden="true">+</span></button>';
        } else {
          html += '<button type="button" class="fa-cart-upsell-add fa-cart-om-upsell-add" data-add-variant="' + escapeHtml(String(variant.id)) + '" aria-label="' + escapeHtml((CONFIG.copy && CONFIG.copy.upsellAddText) || "Add") + '"><span aria-hidden="true">+</span></button>';
        }
        card.innerHTML = html;
        list.appendChild(card);
      }
      wrap.hidden = false;
    }).catch(function (err) { console.warn("[fa-cart] upsells failed", err); });
  }

  // OM cards stack vertically (inline list + side rail) — scroll the
  // list vertically. The nav buttons are visually hidden in this skin
  // but the handler stays wired so nothing crashes if a theme unhides
  // them.
  function scrollUpsells(dir) {
    var list = elements.upsells;
    if (!list) return;
    var step = (list.clientHeight || list.clientWidth) - 24;
    list.scrollBy({ top: dir * step, behavior: "smooth" });
  }

  // ── Quick-view side panel ─────────────────────────────────────
  // Ported from the fa-om-recommendations quick-view engine: the rail
  // "+" slides a second panel over the cart, hydrated client-side from
  // the public /products/<handle>.js JSON (cached per handle). Its ATC
  // posts /cart/add.js (response checked) and returns to the cart.
  var qvCache = {};
  var qvSt = { product: null, variant: null, sel: [], qty: 1, url: "", trigger: null };

  function qvRoot() { return elements.qv; }
  function qvEl(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  function qvMoney(cents) { return formatMoney(cents, state.currency); }
  function qvImgUrl(src, w) {
    if (!src) return "";
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }
  function qvOptions(p) { return (p && p.options) || []; }
  function qvColorPos(p) {
    var os = qvOptions(p);
    for (var i = 0; i < os.length; i++) {
      var n = String(os[i].name || "").toLowerCase();
      if (n === "color" || n === "colour") return i;
    }
    return -1;
  }
  function qvVariantFor(sel) {
    var vs = (qvSt.product && qvSt.product.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (vs[i].options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return vs[i];
    }
    return null;
  }
  // A value is "available" when SOME variant carrying it is; for
  // non-colour options the check is scoped to the selected colour
  // (sold-out combinations read "— Sold out").
  function qvValueAvailable(pos, val, lockColor) {
    var vs = (qvSt.product && qvSt.product.variants) || [];
    var ci = qvColorPos(qvSt.product);
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.options[pos] !== val) continue;
      if (lockColor && ci > -1 && pos !== ci && v.options[ci] !== qvSt.sel[ci]) continue;
      if (v.available) return true;
    }
    return false;
  }
  function qvColorImage(ci, val) {
    var vs = (qvSt.product && qvSt.product.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].options[ci] === val && vs[i].featured_image && vs[i].featured_image.src) return vs[i].featured_image;
    }
    return null;
  }

  // Photos: the same image set into BOTH hosts — the ≥1068px slide-out
  // side strip (vertical y-snap) and the mobile strip (horizontal
  // x-snap); CSS shows one per breakpoint.
  function qvRenderPhotos() {
    var imgs = (qvSt.product && qvSt.product.images) || [];
    var hosts = [elements.qvTrack, elements.qvStrip];
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (!host) continue;
      host.replaceChildren();
      for (var i = 0; i < imgs.length; i++) {
        var slide = qvEl("div", "fa-cart-om-qv-slide");
        var im = document.createElement("img");
        im.src = qvImgUrl(imgs[i], 720);
        im.alt = (qvSt.product && qvSt.product.title) || "";
        im.loading = i > 1 ? "lazy" : "eager";
        slide.appendChild(im);
        host.appendChild(slide);
      }
    }
  }
  // variant.featured_image.position is a 1-based index into
  // product.images — scroll both photo hosts to that slide.
  function qvScrollToImage(fi) {
    if (!fi || !fi.position) return;
    var idx = fi.position - 1;
    function go(host, axis) {
      if (!host || !host.children[idx] || !host.children[0]) return;
      var c = host.children[idx];
      var f = host.children[0];
      try {
        if (axis === "x") host.scrollTo({ left: c.offsetLeft - f.offsetLeft, behavior: "smooth" });
        else host.scrollTo({ top: c.offsetTop - f.offsetTop, behavior: "smooth" });
      } catch (_) {}
    }
    go(elements.qvStrip, "x");
    go(elements.qvTrack, "y");
  }

  function qvColorRow(opt, pos) {
    var row = qvEl("div", "fa-cart-om-qv-optrow");
    var lab = qvEl("div", "fa-cart-om-qv-optlabel");
    lab.appendChild(document.createTextNode(opt.name + " : "));
    var valEl = qvEl("span", "fa-cart-om-qv-optvalue", qvSt.sel[pos] || "");
    valEl.setAttribute("data-fa-om-qv-optvalue", String(pos));
    lab.appendChild(valEl);
    row.appendChild(lab);
    var wrap = qvEl("div", "fa-cart-om-qv-swatches");
    for (var i = 0; i < opt.values.length; i++) {
      (function (val) {
        var b = qvEl("button", "fa-cart-om-qv-swatch");
        b.type = "button";
        b.title = val;
        b.setAttribute("aria-label", opt.name + " — " + val);
        var fi = qvColorImage(pos, val);
        var im = document.createElement("img");
        im.alt = val;
        im.loading = "lazy";
        im.src = qvImgUrl(fi ? fi.src : ((qvSt.product && qvSt.product.featured_image) || ""), 180);
        b.appendChild(im);
        if (!qvValueAvailable(pos, val, false)) b.classList.add("is-soldout");
        if (qvSt.sel[pos] === val) b.classList.add("is-active");
        b.addEventListener("click", safe(function () {
          qvSt.sel[pos] = val;
          qvAdjustSelection(pos);
          qvResolve();
          qvScrollToImage(qvColorImage(pos, val));
        }));
        wrap.appendChild(b);
      })(opt.values[i]);
    }
    row.appendChild(wrap);
    return row;
  }
  // After a colour switch, hop to that colour's first available variant
  // if the carried-over size no longer exists / is sold out.
  function qvAdjustSelection(ci) {
    var v = qvVariantFor(qvSt.sel);
    if (v && v.available) return;
    var vs = (qvSt.product && qvSt.product.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].options[ci] === qvSt.sel[ci] && vs[i].available) { qvSt.sel = vs[i].options.slice(); return; }
    }
  }
  function qvSelectRow(opt, pos) {
    var row = qvEl("div", "fa-cart-om-qv-optrow");
    var lab = qvEl("div", "fa-cart-om-qv-optlabel");
    lab.appendChild(document.createTextNode(opt.name + " : "));
    var valEl = qvEl("span", "fa-cart-om-qv-optvalue", qvSt.sel[pos] || "");
    valEl.setAttribute("data-fa-om-qv-optvalue", String(pos));
    lab.appendChild(valEl);
    row.appendChild(lab);
    var sel = document.createElement("select");
    sel.className = "fa-cart-om-qv-select";
    sel.setAttribute("data-fa-om-qv-select", String(pos));
    sel.setAttribute("aria-label", opt.name);
    for (var i = 0; i < opt.values.length; i++) {
      var o = document.createElement("option");
      o.value = opt.values[i];
      var avail = qvValueAvailable(pos, opt.values[i], true);
      o.textContent = avail ? opt.values[i] : opt.values[i] + " — " + OM_QV_SOLDOUT_LABEL;
      o.disabled = !avail;
      if (qvSt.sel[pos] === opt.values[i]) o.selected = true;
      sel.appendChild(o);
    }
    sel.addEventListener("change", safe(function () {
      qvSt.sel[pos] = sel.value;
      qvResolve();
    }));
    row.appendChild(sel);
    return row;
  }

  function qvRenderInfo() {
    var info = elements.qvInfo;
    if (!info) return;
    var p = qvSt.product;
    info.replaceChildren();
    info.appendChild(qvEl("h3", "fa-cart-om-qv-name", p.title || ""));
    var line = qvEl("p", "fa-cart-om-qv-priceline");
    line.setAttribute("data-fa-om-qv-priceline", "");
    info.appendChild(line);
    var noteTxt = (qvRoot() && qvRoot().getAttribute("data-fa-om-qv-shipnote")) || "";
    if (noteTxt) {
      // [brackets] mark the part that links to the shipping policy;
      // no brackets = plain text, no link at all.
      var tax = qvEl("p", "fa-cart-om-qv-tax");
      var lb = noteTxt.indexOf("[");
      var rb = noteTxt.indexOf("]");
      if (lb !== -1 && rb > lb) {
        if (lb > 0) tax.appendChild(document.createTextNode(noteTxt.slice(0, lb)));
        var a = qvEl("a", "", noteTxt.slice(lb + 1, rb));
        a.href = "/policies/shipping-policy";
        tax.appendChild(a);
        if (rb + 1 < noteTxt.length) tax.appendChild(document.createTextNode(noteTxt.slice(rb + 1)));
      } else {
        tax.appendChild(document.createTextNode(noteTxt));
      }
      info.appendChild(tax);
    }
    var os = qvOptions(p);
    var ci = qvColorPos(p);
    var single = os.length === 1 && os[0] && os[0].values && String(os[0].values[0]) === "Default Title";
    if (!single) {
      for (var i = 0; i < os.length; i++) {
        if (i === ci) info.appendChild(qvColorRow(os[i], i));
        else info.appendChild(qvSelectRow(os[i], i));
      }
    }
  }

  // Reactive pass: variant lookup, price+SAVE line, label values,
  // swatch active states, per-size sold-out options, ATC state,
  // details href.
  function qvResolve() {
    var p = qvSt.product;
    var info = elements.qvInfo;
    if (!p || !info) return;
    var v = qvVariantFor(qvSt.sel);
    qvSt.variant = v;
    var line = info.querySelector("[data-fa-om-qv-priceline]");
    if (line) {
      line.replaceChildren();
      var price = v ? v.price : p.price;
      var cmp = v ? v.compare_at_price : p.compare_at_price;
      if (cmp && cmp > price) {
        var del = document.createElement("del");
        del.textContent = qvMoney(cmp);
        line.appendChild(del);
        var ins = document.createElement("ins");
        ins.textContent = qvMoney(price);
        line.appendChild(ins);
        line.appendChild(qvEl("span", "fa-cart-om-qv-save", ((CONFIG.copy && CONFIG.copy.savingsLabel) || "Save") + " " + qvMoney(cmp - price)));
      } else {
        var only = document.createElement("ins");
        only.textContent = qvMoney(price);
        line.appendChild(only);
      }
    }
    var vals = info.querySelectorAll("[data-fa-om-qv-optvalue]");
    for (var i = 0; i < vals.length; i++) {
      var pos = parseInt(vals[i].getAttribute("data-fa-om-qv-optvalue"), 10);
      vals[i].textContent = qvSt.sel[pos] || "";
    }
    var ci = qvColorPos(p);
    if (ci > -1) {
      var sws = info.querySelectorAll(".fa-cart-om-qv-swatch");
      var cvals = qvOptions(p)[ci].values;
      for (var s = 0; s < sws.length; s++) {
        sws[s].classList.toggle("is-active", cvals[s] === qvSt.sel[ci]);
      }
    }
    var sels = info.querySelectorAll("[data-fa-om-qv-select]");
    for (var q = 0; q < sels.length; q++) {
      var pos2 = parseInt(sels[q].getAttribute("data-fa-om-qv-select"), 10);
      var ovals = qvOptions(p)[pos2].values;
      for (var r = 0; r < sels[q].options.length; r++) {
        var avail = qvValueAvailable(pos2, ovals[r], true);
        sels[q].options[r].disabled = !avail;
        sels[q].options[r].textContent = avail ? ovals[r] : ovals[r] + " — " + OM_QV_SOLDOUT_LABEL;
      }
      sels[q].value = qvSt.sel[pos2];
    }
    var can = !!(v && v.available);
    if (elements.qvAtc) elements.qvAtc.disabled = !can;
    if (elements.qvAtcText) elements.qvAtcText.textContent = can ? OM_QV_ATC_LABEL : OM_QV_SOLDOUT_LABEL;
    if (elements.qvDetails) elements.qvDetails.href = qvSt.url || p.url || "#";
  }

  function qvSetQty(n) {
    n = parseInt(n, 10);
    if (!(n >= 1)) n = 1;
    qvSt.qty = n;
    if (elements.qvQty) elements.qvQty.value = String(n);
    if (elements.qvMinus) elements.qvMinus.disabled = n <= 1;
  }

  function qvFail(msg) {
    if (elements.qvErr) { elements.qvErr.textContent = msg; elements.qvErr.hidden = false; }
  }

  function qvHydrate(p) {
    qvSt.product = p;
    var vs = p.variants || [];
    var first = null;
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) { first = vs[i]; break; } }
    if (!first && vs.length) first = vs[0];
    qvSt.sel = first ? first.options.slice() : [];
    qvRenderPhotos();
    qvRenderInfo();
    qvResolve();
  }

  // Client-side "Ships by …" refresh with weekend skip.
  function qvRefreshShipDate() {
    var sd = elements.qvShipDate;
    if (!sd) return;
    var days = parseInt(sd.getAttribute("data-days"), 10);
    if (isNaN(days)) days = 2;
    var d = new Date();
    d.setDate(d.getDate() + days);
    if (d.getDay() === 6) d.setDate(d.getDate() + 2);
    else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    // Storefront language (html[lang]) wins over the browser locale so
    // the date reads in the shop's language for every visitor.
    var loc = (document.documentElement && document.documentElement.lang) || undefined;
    try { sd.textContent = d.toLocaleDateString(loc, { weekday: "short", month: "short", day: "numeric" }); }
    catch (_) { try { sd.textContent = d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" }); } catch (_e) {} }
  }

  function qvShow(btn) {
    var qv = qvRoot();
    if (!qv) return;
    var handle = btn.getAttribute("data-fa-om-qv-open");
    if (!handle) return;
    qvSt.trigger = btn;
    qvSt.url = btn.getAttribute("data-qv-url") || "";
    if (elements.qvErr) elements.qvErr.hidden = true;
    qvSetQty(1);
    qvRefreshShipDate();
    qv.classList.add("is-open");
    try { qv.focus(); } catch (_) {}
    if (elements.qvBar) {
      elements.qvBar.style.width = "0%";
      setTimeout(safe(function () { elements.qvBar.style.width = "40%"; }), 350);
    }
    if (qvCache[handle]) { qvHydrate(qvCache[handle]); return; }
    // Placeholder title while the JSON loads.
    if (elements.qvInfo) {
      elements.qvInfo.replaceChildren();
      elements.qvInfo.appendChild(qvEl("h3", "fa-cart-om-qv-name", btn.getAttribute("data-qv-title") || ""));
    }
    qv.classList.add("is-loading");
    fetchProduct(handle)
      .then(function (p) {
        qvCache[handle] = p;
        qv.classList.remove("is-loading");
        qvHydrate(p);
      })
      .catch(function () {
        qv.classList.remove("is-loading");
        qvFail(OM.qvErrorText || "Could not load this product — please try again.");
      });
  }

  function qvHide() {
    var qv = qvRoot();
    if (!qv) return;
    qv.classList.remove("is-open");
    if (qvSt.trigger) {
      try { qvSt.trigger.focus(); } catch (_) {}
      qvSt.trigger = null;
    }
  }
  function qvIsOpen() {
    var qv = qvRoot();
    return !!(qv && qv.classList.contains("is-open"));
  }

  // ATC: POST /cart/add.js (response checked — e.g. a 422 out-of-stock
  // race) → refresh the cart → slide back to the cart panel. The
  // __faCartOurAdd flag stops the network interceptor from
  // double-triggering the open animation.
  function qvAddToCart() {
    var v = qvSt.variant;
    var btn = elements.qvAtc;
    if (!v || !btn || btn.disabled || btn.classList.contains("is-loading")) return;
    if (elements.qvErr) elements.qvErr.hidden = true;
    btn.classList.add("is-loading");
    window.__faCartOurAdd = true;
    addItem(v.id, qvSt.qty)
      .then(function () { return refresh(); })
      .then(function () {
        btn.classList.remove("is-loading");
        window.__faCartOurAdd = false;
        qvHide();
      })
      .catch(function () {
        btn.classList.remove("is-loading");
        window.__faCartOurAdd = false;
        qvFail("Could not add to cart — please try again.");
      });
  }

  function updateLine(line, quantity) {
    changeLine(line, quantity).then(render).catch(function (err) {
      console.warn("[fa-cart] change failed", err);
      // Resync with server in case the line/quantity is stale.
      refresh();
    });
  }

  function applyDiscount() {
    var input = elements.discountInput;
    var msg = elements.discountMsg;
    if (!input || !msg) return;
    var code = (input.value || "").trim();
    if (!code) {
      msg.className = "fa-cart-discount-msg is-err";
      msg.textContent = "Enter a code";
      return;
    }
    try { localStorage.setItem(DISCOUNT_KEY, code); } catch (_) {}
    msg.className = "fa-cart-discount-msg is-ok";
    msg.textContent = "Code will be applied at checkout";
  }

  function getStoredDiscount() {
    try { return localStorage.getItem(DISCOUNT_KEY) || ""; } catch (_) { return ""; }
  }

  function goToCheckout(btn) {
    // Auto-applied checkpoint code wins; otherwise fall back to a
    // manually entered code stored from the discount input.
    var code = state.unlockedCode || getStoredDiscount();
    var url = "/checkout";
    if (code) url += "?discount=" + encodeURIComponent(code);
    if (btn) {
      // Disable briefly to prevent double-click spamming, but ALWAYS
      // self-clear after 4s so a back-button return or a failed
      // navigation never leaves the button greyed out.
      btn.setAttribute("disabled", "disabled");
      setTimeout(safe(function () { btn.removeAttribute("disabled"); }), 4000);
    }
    window.location.href = url;
  }

  function bindEvents() {
    // Open from any cart icon / link to /cart, anywhere on the page.
    // Capture phase so we run before theme handlers; modifier keys
    // fall through (cmd-click, middle click, shift).
    document.addEventListener("click", safe(function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;

      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

      var openCart = target.closest('a[href$="/cart"], a[href*="/cart?"], [data-fa-open-cart]');
      if (openCart) {
        e.preventDefault();
        refresh().then(openDrawer);
        return;
      }
      var closeBtn = target.closest("[data-fa-cart-close]");
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var sticky = target.closest("#fa-cart-sticky");
      if (sticky) {
        e.preventDefault();
        refresh().then(openDrawer);
        return;
      }
      var checkout = target.closest("[data-fa-checkout]");
      if (checkout) {
        e.preventDefault();
        goToCheckout(checkout);
        return;
      }
    }), true);

    // ESC key: the quick view closes first (back to the cart), a
    // second ESC closes the drawer.
    document.addEventListener("keydown", safe(function (e) {
      if (e.key !== "Escape") return;
      if (qvIsOpen()) { qvHide(); return; }
      if (elements.drawer && elements.drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    }));

    // Inside-drawer interactions — qty +/-, remove, upsell add, discount.
    var d = elements.drawer;
    if (d) {
      d.addEventListener("click", safe(function (e) {
        var target = e.target;
        if (!(target instanceof Element)) return;
        var li = target.closest(".fa-cart-item");
        if (li) {
          var line = parseInt(li.getAttribute("data-line"), 10);
          if (!line) return;
          var item = state.cart && state.cart.items && state.cart.items[line - 1];
          if (!item) return;
          if (target.closest("[data-qty-inc]")) {
            updateLine(line, item.quantity + 1);
          } else if (target.closest("[data-qty-dec]")) {
            if (item.quantity <= 1) return;
            updateLine(line, item.quantity - 1);
          } else if (target.closest("[data-qty-remove]")) {
            updateLine(line, 0);
          }
        }
        // Rail "+" → quick-view side panel.
        var qvOpen = target.closest("[data-fa-om-qv-open]");
        if (qvOpen) {
          e.preventDefault();
          qvShow(qvOpen);
          return;
        }
        var qvClose = target.closest("[data-fa-om-qv-close]");
        if (qvClose) {
          e.preventDefault();
          qvHide();
          return;
        }
        if (target.closest("[data-fa-om-qv-minus]")) { qvSetQty(qvSt.qty - 1); return; }
        if (target.closest("[data-fa-om-qv-plus]")) { qvSetQty(qvSt.qty + 1); return; }
        if (target.closest("[data-fa-om-qv-atc]")) { qvAddToCart(); return; }
        var addBtn = target.closest("[data-add-variant]");
        if (addBtn) {
          var vid = addBtn.getAttribute("data-add-variant");
          if (vid) {
            addBtn.setAttribute("disabled", "disabled");
            addItem(vid, 1)
              .then(function () { return refresh(); })
              .catch(function (err) { console.warn("[fa-cart] add upsell failed", err); })
              .then(function () { addBtn.removeAttribute("disabled"); });
          }
        }
        var apply = target.closest("[data-fa-discount-apply]");
        if (apply) {
          e.preventDefault();
          applyDiscount();
        }
        var prev = target.closest("[data-fa-upsell-prev]");
        if (prev) { e.preventDefault(); scrollUpsells(-1); }
        var next = target.closest("[data-fa-upsell-next]");
        if (next) { e.preventDefault(); scrollUpsells(1); }
      }));
      // Typed quantity in the quick view.
      if (elements.qvQty) {
        elements.qvQty.addEventListener("change", safe(function () {
          qvSetQty(elements.qvQty.value);
        }));
      }
    }

    // Intercept add-to-cart forms — only on success do we preventDefault.
    // If anything fails the form falls back to native submit so the
    // customer is never stranded on a broken add-to-cart.
    document.addEventListener("submit", safe(function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute("action") || "";
      if (!/\/cart\/add/.test(action)) return;
      if (form.getAttribute("data-fa-skip") === "true") return;

      var fd = new FormData(form);
      fd.append("sections", "");
      var canIntercept = "fetch" in window && "FormData" in window;
      if (!canIntercept) return;
      e.preventDefault();
      // We run in the CAPTURE phase on document, i.e. before any of the
      // theme's own bubble-phase submit listeners (Dawn-family themes bind
      // a <product-form> submit handler that ALSO ajax-POSTs /cart/add).
      // Stop the event here so the theme can't add the SAME item a second
      // time — otherwise every PDP add lands in the cart at quantity 2.
      e.stopImmediatePropagation();
      // Tell our fetch monkey-patch this add is ours so it doesn't
      // double-trigger the open animation.
      window.__faCartOurAdd = true;
      fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      }).then(function () { return refresh(); })
        .then(function () { openDrawer(); })
        .catch(function (err) {
          console.warn("[fa-cart] add intercept failed — falling back to native submit", err);
          form.setAttribute("data-fa-skip", "true");
          try { form.submit(); } catch (_) {}
        })
        .then(function () { window.__faCartOurAdd = false; });
    }), true);
  }

  // ── Network interceptors ──────────────────────────────────────
  // Many themes bypass form submits and POST directly via fetch or
  // XHR — our submit listener won't catch those. We monkey-patch
  // both transports so ANY /cart/add* POST opens our drawer on
  // success, regardless of how the theme invoked it. Patches install
  // synchronously at script load so they're in place before the
  // theme's first add-to-cart can fire.
  function installNetworkInterceptors() {
    try {
      if (typeof window.fetch === "function") {
        var origFetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
          var url = "";
          var method = "GET";
          try {
            if (typeof input === "string") { url = input; }
            else if (input && typeof input.url === "string") { url = input.url; method = input.method || method; }
            if (init && init.method) method = init.method;
          } catch (_) {}
          var isAdd = /^POST$/i.test(method) && /\/cart\/add(\.js)?($|[?&#])/.test(url);
          var p = origFetch(input, init);
          if (isAdd && !window.__faCartOurAdd) {
            p.then(function (res) {
              if (!res || !res.ok) return;
              setTimeout(safe(function () {
                refresh().then(safe(openDrawer));
              }), 30);
            }).catch(function () {});
          }
          return p;
        };
      }
    } catch (e) { try { console.warn("[fa-cart] fetch patch failed", e); } catch (_) {} }

    try {
      if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
        var proto = XMLHttpRequest.prototype;
        var origOpen = proto.open;
        var origSend = proto.send;
        proto.open = function (method, url) {
          try {
            this.__faMethod = method || "";
            this.__faUrl = (url == null ? "" : String(url));
          } catch (_) {}
          return origOpen.apply(this, arguments);
        };
        proto.send = function () {
          try {
            var m = this.__faMethod || "";
            var u = this.__faUrl || "";
            if (/^POST$/i.test(m) && /\/cart\/add(\.js)?($|[?&#])/.test(u) && !window.__faCartOurAdd) {
              var xhr = this;
              xhr.addEventListener("load", safe(function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                  setTimeout(safe(function () {
                    refresh().then(safe(openDrawer));
                  }), 30);
                }
              }));
            }
          } catch (_) {}
          return origSend.apply(this, arguments);
        };
      }
    } catch (e) { try { console.warn("[fa-cart] xhr patch failed", e); } catch (_) {} }
  }

  // Install network interceptors immediately — these MUST be in place
  // before any theme code runs an add-to-cart fetch/XHR.
  installNetworkInterceptors();

  function captureElements() {
    elements.drawer = $("#fa-cart-drawer");
    if (!elements.drawer) return false;
    elements.count = $("[data-fa-cart-count]", elements.drawer);
    elements.items = $("[data-fa-cart-items]", elements.drawer);
    elements.empty = $("[data-fa-cart-empty]", elements.drawer);
    elements.shipbar = $("[data-fa-shipbar]", elements.drawer);
    elements.shipbarText = $("[data-fa-shipbar-text]", elements.drawer);
    elements.shipbarFill = $("[data-fa-shipbar-fill]", elements.drawer);
    elements.shipbarTrack = $("[data-fa-shipbar-track]", elements.drawer);
    elements.subtotalFinal = $("[data-fa-subtotal-final]", elements.drawer);
    elements.subtotalCompare = $("[data-fa-subtotal-compare]", elements.drawer);
    elements.savings = $("[data-fa-savings]", elements.drawer);
    elements.omDiscountsRow = $("[data-fa-om-discounts]", elements.drawer);
    elements.checkoutTotal = $("[data-fa-checkout-total]", elements.drawer);
    elements.upsellsWrap = $("[data-fa-upsells-wrap]", elements.drawer);
    elements.upsells = $("[data-fa-upsells]", elements.drawer);
    elements.discountInput = $("[data-fa-discount-input]", elements.drawer);
    elements.discountMsg = $("[data-fa-discount-msg]", elements.drawer);
    elements.sticky = $("#fa-cart-sticky");
    elements.stickyCount = $("[data-fa-sticky-count]");
    elements.checkout = $("[data-fa-checkout]", elements.drawer);
    // Quick-view side panel (absent when styleExtras.om.qvEnabled off).
    elements.qv = $("[data-fa-om-qv]", elements.drawer);
    elements.qvInfo = $("[data-fa-om-qv-info]", elements.drawer);
    elements.qvStrip = $("[data-fa-om-qv-strip]", elements.drawer);
    elements.qvTrack = $("[data-fa-om-qv-photos-track]", elements.drawer);
    elements.qvBar = $("[data-fa-om-qv-bar]", elements.drawer);
    elements.qvShipDate = $("[data-fa-om-qv-shipdate]", elements.drawer);
    elements.qvQty = $("[data-fa-om-qv-qtyin]", elements.drawer);
    elements.qvMinus = $("[data-fa-om-qv-minus]", elements.drawer);
    elements.qvAtc = $("[data-fa-om-qv-atc]", elements.drawer);
    elements.qvAtcText = $("[data-fa-om-qv-atc-text]", elements.drawer);
    elements.qvErr = $("[data-fa-om-qv-error]", elements.drawer);
    elements.qvDetails = $("[data-fa-om-qv-details]", elements.drawer);
    return true;
  }

  // ── Floating Add-to-Cart teardrop ────────────────────────────
  // On product pages (and only there — we abort cleanly when no ATC
  // button is found), watch the native Add-to-Cart button. Show our
  // teardrop when it scrolls out of view, hide when it scrolls back.
  // Clicking the teardrop triggers .click() on the original button so
  // variant selection / quantity / form state all stay intact.
  function initFloatingAtc() {
    var floatBtn = document.getElementById("fa-cart-floatatc");
    if (!floatBtn) return; // setting disabled — element wasn't rendered
    // Mobile-only. Desktop keeps the native ATC + nav real estate.
    try {
      if (window.matchMedia && window.matchMedia("(min-width: 768px)").matches) {
        return;
      }
    } catch (_) {}
    // Don't show on /cart or /checkout — there's no ATC there.
    var path = (location && location.pathname) || "";
    if (/\/(cart|checkout)/.test(path)) return;
    // Try common Shopify theme selectors for the primary ATC button.
    var atc = null;
    var selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] [name="add"]',
      'button[name="add"]',
      '[data-action="add-to-cart"]',
      '.product-form__submit',
      'button.add-to-cart',
    ];
    for (var i = 0; i < selectors.length && !atc; i++) {
      var found = document.querySelector(selectors[i]);
      if (found && found.offsetParent !== null) atc = found;
    }
    if (!atc) return; // not a PDP — leave the teardrop hidden

    floatBtn.hidden = false;
    // Tap = proxy click to the real button so the theme's variant
    // state, qty value, and any add-to-cart enhancement all run.
    floatBtn.addEventListener("click", safe(function (e) {
      e.preventDefault();
      try { atc.click(); } catch (_) {}
    }));

    function setVisible(v) {
      if (v) floatBtn.classList.add("is-visible");
      else floatBtn.classList.remove("is-visible");
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Visible teardrop only when the ATC is OUT of viewport.
        setVisible(!entry.isIntersecting);
      }, { threshold: 0, rootMargin: "0px 0px -40px 0px" });
      io.observe(atc);
    } else {
      // Fallback: scroll listener with getBoundingClientRect.
      var onScroll = safe(function () {
        var r = atc.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight;
        setVisible(!inView);
      });
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      onScroll();
    }
  }

  function init() {
    if (!captureElements()) return;
    bindEvents();
    renderUpsells();
    refresh();
    initFloatingAtc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
